import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';

/**
 *  Guard on reset-password page, to not let users access the page without token in query-params
 *
 * @export
 * @class ResetPasswordGuard
 * @implements {CanActivate}
 * @implements {CanActivateChild}
 */
@Injectable({
  providedIn: 'root'
})
export class ResetPasswordGuard  {
  constructor(private router: Router) {}

  /**
   *  This method is used for authenticate the route
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {boolean}
   *
   * @memberOf ResetPasswordGuard
   */
  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (route.queryParams['token'] !== undefined) {
      return true;
    } else {
      this.router.navigate(['login']);
      return false;
    }
  }
}
